import { ReactNode } from 'react';
import {
  BaseButton,
  BASE_BUTTON_VARIANT,
  BASE_BUTTON_COLOR,
} from '~/components/Global/Button';
import { BaseDialog } from './BaseDialog';

type TProps = {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmText?: string;
  onClose: () => void;
};

/**
 * @description 共用的提示彈窗（單一「確定」按鈕）。title 與內文由呼叫端傳入。
 */
export const AlertDialog = ({
  open,
  title,
  children,
  confirmText = '確定',
  onClose,
}: TProps) => {
  return (
    <BaseDialog
      open={open}
      handleClose={onClose}
      title={title}
      width="400px"
      action={
        <BaseButton
          variant={BASE_BUTTON_VARIANT.FILLED}
          color={BASE_BUTTON_COLOR.PRIMARY}
          text={confirmText}
          onClick={onClose}
        />
      }
    >
      {children}
    </BaseDialog>
  );
};
